export default class InboxOperation {
  constructor(el) {
    this.el = el;
    this.selectBox = document.querySelector('select[name="action"]');
    this.ListContainer = this.el.getAttribute('data-messages-list-items');
    this.currentFolder = document.querySelector('input[name="ordner"]').value;
    this.listItems = document.querySelectorAll(this.ListContainer);
    this.checkboxesItems = $(this.listItems).find('input[type="checkbox"]');
    $(this.selectBox).on('change', sel => {
      // Get checked.
      this.msgIds = [];
      $('input[type="checkbox"]:checked').each((i, elm) => {
        this.ii = i;
        this.msgIds.push(elm.value);
      });
      // Determine action for ajax.
      this.actionValue = sel.currentTarget.value;
      // console.log('actionValue');
      // console.log(this.actionValue);
      let action = '';
      switch (this.actionValue) {
        case 'r':
        case 'ur':
          action = 'set_flag';
          break;
        case 'new':
          action = 'new_folder';
          break;
        case '3':
        case '4':
          action = 'remove';
          break;
        default:
          action = 'move';
      }
      if (this.msgIds.length > 0) {
        this._doOperation(
          this.currentFolder,
          action,
          this.actionValue,
          this.msgIds
        );
      } else {
        // console.log('0 message(s) selected.');
      }
      this._resetAll();
    });
  }

  /* eslint-disable class-methods-use-this */
  _doOperation(current, action, value, ids) {
    switch (action) {
      case 'move':
      case 'remove':
        // console.log('remove items from view');
        this._removeItems();
        this._execute(current, action, value, ids);
        break;
      case 'set_flag':
        // console.log('change flags');
        this._execute(current, action, value, ids);
        break;
      default:
        this._freeMe();
    }
  }

  _resetAll() {
    $(this.selectBox).val('');
  }

  _removeItems() {
    // console.log(this.checkboxesItems);
  }

  _freeMe() {
    this.ii = 0;
  }

  _execute(current, action, value, ids) {
    const data = {};
    data.mode = 'send';
    data.current = current;
    data.action = action;
    data.value = value;
    data.ids = ids;
    $.ajax({
      url: '/inbox_operations.php',
      type: 'POST',
      data,
      success: response => {
        // console.log('response');
        // console.log(response);
        window.location = window.location.href;
        if (response.action === 'OK') {
          window.location = window.location.href;
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/inbox_operations.js